import { i18n } from "@/i18n";
import DownloadView from "@/views/Download/DownloadView.vue";

export default {
  path: "/download-file/:action/:base64file/:fileName",
  name: "downloadFile",
  component: DownloadView,
  meta: {
    authRequired: false,
    title: i18n.global.t("page.download.title"),
    breadcrumb: true,
  },
};
